import '@/common';
import { createSmartFilterWidget } from '@/widgets/SmartFilterWidget';

createSmartFilterWidget(document.querySelector('#smart-filter-widget')!);

window.addEventListener('favoritesChange', () => {
    if (window.$favorites.count === 0) {
        document.querySelector('#favorites-list')?.classList.add('favorites-list--empty');
    }
});
